import geekFlixImage from "../../src/images/geekflix.PNG";
import jobTrackingAppImage from "../../src/images/job-tracking-app.png";
import electricityForecasterImage from "../../src/images/electricity-forecaster.PNG";
import georgeBlog from "../../src/images/george-blog.png";

export const skills = [
  "TypeScript",
  ".NET Core",
  "React",
  "Angular",
  "AWS",
  "Azure",
  "Java",
  "Express",
  "Spring",
  "Next",
];

export const projects = [
  {
    title: "Job Tracking App",
    subtitle: "React, .NET, C#, TypeScript",
    description:
      "A web application for tracking job applications, built with React (TypeScript) and .NET (C#). Users can manage company, position, and application status details.",
    image: jobTrackingAppImage,
    link: "https://github.com/georgee99/JobTrackingApp",
  },
  {
    title: "Personal Blog",
    subtitle: "Next.js, DynamoDB, Lambda, API Gateway",
    description:
      "This is a personal blog site built with Next.js, using DynamoDB for database management, Lambda for the serverless functions, and API Gateway for routing.",
    image: georgeBlog,
    link: "https://github.com/georgee99/george-blog",
  },
  {
    title: "Electricity Forecaster",
    subtitle: "Python",
    description:
      "This is a web application which forecasts the price and demand of electricity in Australia using machine learning. It was built in Python using the Dash Framework by Plotly.",
    image: electricityForecasterImage,
    link: "https://github.com/georgee99/Dash",
  },
  {
    title: "Geek Flix Movie App",
    subtitle: "Angular",
    description:
      "Geek Flix is an application which fetches movies from TMDB API, and renders them paginated. Users can sort movies by emotion, or remove them from the collection.",
    image: geekFlixImage,
    link: "https://github.com/georgee99/Angular-Movie-App",
  },
];

export const experienceData = [
  {
    company: "Peninsula Australia",
    description:
      "Developing internal company software with a focus on web applications and automation. I leveraged AWS Cloud Services, including Lambda, SQS, API Gateway, and DynamoDB, to streamline application development and deployment. Automated various tasks, such as user and client management, and implemented comprehensive unit and integration tests to ensure application stability and performance.",
    dates: "August 2023 - Present",
    jobTitle: "Software Engineer",
  },
  {
    company: "Symbio",
    description:
      "Contributed to the maintenance and development of internal company software using Java, Spring, and Hibernate. Developed automated unit and integration tests with JUnit and Mockito. I supported application development and deployment to both on-premise and AWS environments. Utilized Elasticsearch, Logstash, and Kibana to execute queries and implement data changes.",

    dates: "July 2022 - August 2023",
    jobTitle: "Graduate Software Engineer",
  },
  {
    company: "SeaLadder",
    description:
      "I contributed to the development of an online learning platform for Software Engineers, using Angular (TypeScript) and .NET Core (C#). I adopted a test-driven development approach and created unit tests with the Jasmine testing framework. I learned to debug using Chrome Developer Tools and became proficient with version control.",

    dates: "October 2021 - July 2022",
    jobTitle: "Full Stack Developer",
  },
];
